import { render } from "./Habilitation.vue?vue&type=template&id=490e0637"
import script from "./Habilitation.vue?vue&type=script&lang=js"
export * from "./Habilitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__